export default __webpack_public_path__ + "static/media/locker.36a0a2ec.svg";